<template>
  <BaseModal :show.sync="isShow" title="Confirm name change">
    <p>Are you sure you want to change your name?</p>
    <div class="newname-diplayer">{{ fullname }}</div>
    <template #modal-footer>
      <b-button class="button__cancel" variant="secondary" @click="onCancel">Cancel</b-button>
      <b-button class="button__confirm" variant="success" @click="onConfirm">Confirm</b-button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal';
export default {
  components: {
    BaseModal
  },
  props: {
    fullname: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
      this.hide();
    },
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.newname-diplayer {
  font-size: 1.5rem;
  font-weight: bold;
  margin-top: 1rem;
  padding: 0.5rem 2rem;
  border-radius: 10.4px;
  background-color: #eff6ed;
  gap: 10px;
  font-weight: 500;
  font-size: 16px;
}
</style>
